export const buyWineOffersTableName = 'buyWineOffers'
export const sellWineOffersTableName = 'sellWineOffers'

export const BUY_WINE_ANALYSIS = 'accBuyWineAnalysis'

export const OFFERS_ROUTE_NAMES = {
  buyWineOffers: 'accBuyWineOffers',
  sellWineMyOffers: 'accSellWineMyOffers',
  buyWineAnalysis: 'accBuyWineAnalysis',
  buyWineAnalysisRating: 'accBuyWineAnalysisRating',
  buyWineWines: 'accBuyWineWines',
}
